<div id="stars">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <h3 class="card-title">Star Achiever</h3>
                <hr class="pb-1 rounded">
            </div>
        </div>
        <div class="row">
          <img src="/assets/img/star/53.jpg" alt="" class="img-fluid mx-auto">
          <img src="/assets/img/star/54.jpg" alt="" class="img-fluid mx-auto">
            <!-- <div class="col-sm-6 col-md-4 col-xl-3 mt-5" *ngFor="let person of star;let i=index">
                <div class="property-card shadow-lg" >
                    <a href="#">
                      <div class="property-image" [style.background-image]="'url('+person.img+')'">
                        <div class="property-image-title">
                          Optional <h5>Card Title</h5> If you want it, turn on the CSS also.
                        </div>
                      </div></a>
                    <div class="property-description">
                      <h5> {{person.name}} </h5>
                      <p>{{person.degree}}</p>
                    </div>
                    <a >
                      <div class="property-social-icons">
                        I would usually put multipe divs inside here set to flex. Some people might use Ul li. Multiple Solutions
                      </div>
                    </a>
                  </div>
            </div> -->
           
        </div>
    </div>
</div>